import React, { FC } from 'react'
import { DynamicHeroProps } from './DynamicHero.types'
import { sanitizeHTML } from '../../../../utils/common-utils'
import './dynamic-hero.scss'
import { setLayoutAlignment } from '../../../../utils/layout-util'
import { LinkCompound } from '../../../Compounds/src/LinkCompound'
import { ImageCompound } from '../../../Compounds/src/ImageCompound'
import { getFacetImagePath } from '../../../../utils/background-util'

export const DynamicHero: FC<DynamicHeroProps> = props => {
  const { content, testId } = props
  const { heading, body, button, fontColor, facetColor, layout, contentImage } = content

  const backgroundImage = getFacetImagePath(facetColor, { isMobile: false })
  return (
    <section
      className='DynamicHero u-paddingVert20'
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
      data-testid={testId ? `${testId}` : null}
    >
      <div className='Grid u-sizeConstrained u-marginVert32 u-sm-marginVert0'>
        <div
          className={`${setLayoutAlignment(
            layout,
            'left'
          )} u-md-size8of12 u-sm-sizeFull u-paddingVert15 u-paddingRight24 u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsStart`}
        >
          {heading && (
            <h1
              className={`u-textSizeMsrp9 ${fontColor}`}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading) }}
            />
          )}
          {body && (
            <div
              className={`Content Content--large ${fontColor}`}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(body) }}
            />
          )}
          {button && <LinkCompound {...button} classes={['u-marginTop32']} />}
        </div>
        {contentImage && contentImage[0] && (
          <div
            className={`${setLayoutAlignment(
              layout,
              'right'
            )} u-flex u-flexJustifyEnd u-sm-flexJustifyStart u-size4of12 u-md-size4of12 u-sm-sizeFull`}
          >
            <ImageCompound
              alt={contentImage[0].alt}
              title={contentImage[0].title}
              src={contentImage[0].src}
              url={contentImage[0].url}
              imagePosition='full'
            />
          </div>
        )}
      </div>
    </section>
  )
}
